"use client";

import { AuditChooserForm } from "~/components/siteglue/home/audit-chooser-form";

export function HomeHeroScanForm({
  onStepChange: _onStepChange,
}: {
  onStepChange?: (step: number) => void;
} = {}) {
  return (
    <div className="mx-auto w-full max-w-2xl">
      <AuditChooserForm location="homepage_hero" />
    </div>
  );
}
